import Report from './report'
import Diagram from './diagram'
import RichTextBox from './richTextBox'
import TextControl from './textControl'
import UrlPage from './urlPage'
import Calendar from './calendar'
import Clock from './clock'
import Decorate from './decorate'
export default class Controls {
  constructor (args) {
    if (!args || typeof args !== 'object') {
      throw new Error('参数不合法')
    }
    switch (args.type) {
      case 'report':
        return new Report(args)
      case 'diagram':
        return new Diagram(args)
      case 'rich-text-box':
        return new RichTextBox(args)
      case 'text-control':
        return new TextControl(args)
      case 'url-page':
        return new UrlPage(args)
      case 'calendar':
        return new Calendar(args)
      case 'clock':
        return new Clock(args)
      case 'decorate':
        return new Decorate(args)
      default:
        throw new Error('未知类型')
    }
  }
  /**
   * 处理宽度
   * @param container {Object | HTMLElement | Number} 需要处理的父容器/宽度
   * @param controls {Array} 需要处理的数组
   * @param designStyle {Object} 上一次设计的时候的宽高
   * @param resizeTH 是否修改top和高度
   * */
  static adapterWidth (container, controls, designStyle, resizeTH) {
    // 如果redcat-app升级之后可以将下面这段代码替换
    // const parentDom = container instanceof HTMLElement ? container : typeof container === 'number' ? container : container?.$el
    // const parentWidth = parentDom?.getBoundingClientRect?.()?.width ?? parentDom
    // // 根据父容器适配宽度
    // parentWidth && controls?.forEach(c => c?.updateHeightOrWidth(parentWidth, designStyle))
    let width = 0
    if (typeof container === 'number') {
      width = container
    } else if (typeof container === 'object') {
      width = container.getBoundingClientRect().width
    }
    // 根据父容器适配宽度
    if (width > 0) {
      controls && controls.forEach(c => c && c.updateHeightOrWidth(width, designStyle, resizeTH))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/report/design/customPage/assets/js/controls.js